import {Routes, Route, Navigate, Outlet} from 'react-router-dom';
import {SingleCard} from './layouts';
import {LoginForm} from './components';
import React, {useEffect} from "react";
import useApi from "./hooks/useApi";

export default function UnauthenticatedContent() {
    const {data: isEntrepriseExistante, getData} = useApi("entreprise/isEntrepriseExistante")
    useEffect(() => {
        getData()
    }, [])
    if (!isEntrepriseExistante)
        return <div>Compagine invalide</div>
    return (
        <Routes>
            <Route path={"login"} element={
                <SingleCard title="Connexion">
                    <LoginForm/>
                </SingleCard>
            }/>
            <Route path={"/*"} element={<Navigate to={`login`}/>}/>
        </Routes>);
}
